import React from 'react'; 
import './Process.css';

import { Heading, ProcessStep } from '../../../components';
import { process } from '../../../constants';



const Process = () => {

  return (
 
      <section className='process'>

        {/* Section heading */}
        <Heading title={'Our Booking Process'} subTitle={'How We Work'} />

        <div className='box-container'>

          {/* Map over the process array to render each step */}
          {process.map((step) => { 
            return (
              <ProcessStep key={step.id} step={step} />
            );
          })}
        </div>

      </section>

  );
}

export default Process;